import { render, staticRenderFns } from "./CardInstrument.vue?vue&type=template&id=629f18ca&scoped=true&"
import script from "./CardInstrument.vue?vue&type=script&lang=ts&"
export * from "./CardInstrument.vue?vue&type=script&lang=ts&"
import style0 from "./CardInstrument.vue?vue&type=style&index=0&id=629f18ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f18ca",
  null
  
)

export default component.exports